import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';

const apiBaseURL = 'https://plasticemployers.duckdns.org';
const MEDIA_BASE_URL = 'https://plasticemployers.duckdns.org/media/';

const countries = [
  { label: 'Austria', value: 'AT' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'Germany', value: 'DE' },
  { label: 'Greece', value: 'EL' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Italy', value: 'IT' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Malta', value: 'MT' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Romania', value: 'RO' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sweden', value: 'SE' },
  { label: 'United Kingdom', value: 'GB' },
];

const Vies = () => {
  const [country, setCountry] = useState('');
  const [vat, setVat] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [pdfUrl, setPdfUrl] = useState(null);

  const handleSubmit = async () => {
    setError('');
    setResult(null);
    setPdfUrl(null);
    try {
      const response = await axios.get(`${apiBaseURL}/api/vies-certificates/`, {
        params: { countryCode: country, vatNumber: vat },
      });
      // handle paginated and non-paginated response
      const items = response.data.results || response.data;
      if (items.length > 0) {
        // assume first item is the most recent
        const latest = items[0];
        setResult(latest.valid);
        if (latest.pdf_url) {
          // revoke old URL if any
          setPdfUrl(old => {
            if (old) URL.revokeObjectURL(old);
            return null;
          });
          // fetch PDF blob and create object URL
          axios.get(latest.pdf_url, { responseType: 'blob' })
            .then(resp => {
              const url = URL.createObjectURL(resp.data);
              setPdfUrl(url);
            })
            .catch(e => {
              console.error('Erro ao carregar PDF:', e);
              setPdfUrl(null);
            });
        }
      } else {
        setError('Nenhuma certificação encontrada');
      }
    } catch (err) {
      console.error('Erro ao buscar certificado VIES:', err);
      setError('Erro ao buscar certificado VIES');
    }
  };

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Verificação VIES
      </Typography>
      <FormControl fullWidth margin="normal">
        <InputLabel>País</InputLabel>
        <Select
          value={country}
          label="País"
          onChange={(e) => setCountry(e.target.value)}
        >
          {countries.map((c) => (
            <MenuItem key={c.value} value={c.value}>
              {c.label} ({c.value})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        margin="normal"
        label="Contribuinte (VAT)"
        value={vat}
        onChange={(e) => setVat(e.target.value)}
      />
      <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={!country || !vat}
        sx={{ mt: 2 }}
      >
        Verificar
      </Button>
      {result !== null && (
        <Typography
          variant="subtitle1"
          sx={{ mt: 2, color: result ? 'success.main' : 'error.main' }}
        >
          {result ? 'Inscrito no VIES' : 'Não inscrito no VIES'}
        </Typography>
      )}
      {error && (
        <Typography variant="subtitle1" color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      {pdfUrl && (
        <Box mt={2}>
          <Typography variant="subtitle1" gutterBottom>
            Visualização do PDF:
          </Typography>
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="500px"
            style={{ border: 'none' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Vies;
